<style>
  #dropzone{
    width:100%;
    display:block;
    text-align: center;
    position: relative;
  }
  dz-preview {
    text-align: left;
    float:left;
    display: inline-block;
  }
  .dz-error-message{
    display: none !important;
  }
  .dropzone{
    border: 2px dashed #0087F7 !important;
    border-radius: 5px;
    background: white;
  }
  .dz-message{
    font-weight: bold;
    text-align: center;
  }
  .start_upload{
    text-align: center;
    width: 150px;
    position: absolute;
    bottom: 0;
    right: 0;
    margin: 10px 15px 15px 15px;
  }

</style>

<template>
  <div id="app">
    <dropzone  id="myVueDropzone" :url="url" v-on:vdropzone-success="showSuccess">
      <!-- Optional parameters if any! -->
      <input type="hidden" name="token" value="xxx">
    </dropzone>
  </div>
</template>

<script>
  import Dropzone from 'vue2-dropzone'
  import constants from '../../lib/constants' ;

  export default {
    name: 'MainApp',
    components: {
      Dropzone,
    },
    data() {
      return {
        url:constants.API_HOST + constants.API_UEDITOR_UPLOAD
      }
    },
    mounted(){

    },
    methods:{
      showSuccess (file) {
        console.log(eval('('+file.xhr.response+')').url);
        console.log(file.name.split(".")[0],120);
        this.$emit("upup",eval('('+file.xhr.response+')').url)
      },
    }
  };

</script>



// WEBPACK FOOTER //
// upload-img.vue?159a9d86